import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "betting-action-btn-icon",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "betting-pick-action__label" }
const _hoisted_3 = ["aria-expanded", "aria-label"]
const _hoisted_4 = { class: "betting-pick-action__count" }
const _hoisted_5 = ["onClick"]

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

interface Props {
  variant: 'quick' | 'hot' | 'cold'
  platform: 'desktop' | 'mobile'
  pickOptions: number[]
  selectedCount: number
  menuLabel?: string
  active?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BettingPickActionButton',
  props: {
    variant: {},
    platform: {},
    pickOptions: {},
    selectedCount: {},
    menuLabel: {},
    active: { type: Boolean, default: false }
  },
  emits: ["action", "update:selectedCount"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const menuOpen = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)
const toggleRef = ref<HTMLElement | null>(null)
const menuRef = ref<HTMLElement | null>(null)
const menuPositionStyle = ref<Record<string, string>>({})

const showDropdown = computed(() => props.pickOptions.length >= 1)

const positionMenu = () => {
  const anchor = toggleRef.value ?? dropdownRef.value
  if (!anchor) return

  const rect = anchor.getBoundingClientRect()
  menuPositionStyle.value = {
    position: 'fixed',
    top: `${rect.top - 6}px`,
    left: `${rect.right}px`,
    transform: 'translate(-100%, -100%)',
    zIndex: '10000',
  }
}

const closeMenu = () => {
  menuOpen.value = false
}

const toggleMenu = async () => {
  menuOpen.value = !menuOpen.value
  if (menuOpen.value) {
    await nextTick()
    positionMenu()
  }
}

const handleReposition = () => {
  if (menuOpen.value) {
    positionMenu()
  }
}

const selectCount = (count: number) => {
  emit('update:selectedCount', count)
  emit('action', count)
  closeMenu()
}

const handleDocumentClick = (event: MouseEvent) => {
  if (!menuOpen.value) return
  const target = event.target as Node
  if (dropdownRef.value?.contains(target)) return
  if (menuRef.value?.contains(target)) return
  closeMenu()
}

watch(() => props.pickOptions, () => {
  closeMenu()
})

onMounted(() => {
  document.addEventListener('click', handleDocumentClick)
  window.addEventListener('scroll', handleReposition, true)
  window.addEventListener('resize', handleReposition)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick)
  window.removeEventListener('scroll', handleReposition, true)
  window.removeEventListener('resize', handleReposition)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["betting-pick-action", [
      `betting-pick-action--${_ctx.platform}`,
      `betting-pick-action--${_ctx.variant}`,
      { 'betting-pick-action--has-menu': showDropdown.value },
      { 'betting-pick-action--active': _ctx.active }
    ]])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "betting-pick-action__main",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('action', _ctx.selectedCount)))
    }, [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    (showDropdown.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "dropdownRef",
          ref: dropdownRef,
          class: "betting-pick-action__menu-wrap"
        }, [
          _createElementVNode("button", {
            ref_key: "toggleRef",
            ref: toggleRef,
            type: "button",
            class: "betting-pick-action__toggle",
            "aria-expanded": menuOpen.value,
            "aria-label": props.menuLabel ?? 'Select number of balls',
            onClick: _withModifiers(toggleMenu, ["stop"])
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedCount), 1),
            _cache[1] || (_cache[1] = _createElementVNode("svg", {
              viewBox: "0 0 12 8",
              fill: "none",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", {
                d: "M1 1.5L6 6.5L11 1.5",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1))
          ], 8, _hoisted_3),
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            (menuOpen.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref_key: "menuRef",
                  ref: menuRef,
                  class: _normalizeClass(["betting-pick-action__menu", `betting-pick-action__menu--${_ctx.variant}`]),
                  style: _normalizeStyle(menuPositionStyle.value)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pickOptions, (count) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: count,
                      type: "button",
                      class: _normalizeClass(["betting-pick-action__menu-item", { active: count === _ctx.selectedCount }]),
                      onClick: ($event: any) => (selectCount(count))
                    }, _toDisplayString(count), 11, _hoisted_5))
                  }), 128))
                ], 6))
              : _createCommentVNode("", true)
          ]))
        ], 512))
      : _createCommentVNode("", true)
  ], 2))
}
}

})